// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyCwTHrYlQdP8WMrnE9752TJHB3H6J_-AiM",
  authDomain: "carschalao-f0501.firebaseapp.com",
  projectId: "carschalao-f0501",
  storageBucket: "carschalao-f0501.firebasestorage.app",
  messagingSenderId: "42760797225",
  appId: "1:42760797225:web:fea6464c835d654267b038"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
export { db };